'use strict';

var app = require('angular').module('app');
//old GA UA-60732327-9 PROD
app.constant('isDebug', true);
app.constant('analyticsTrackingId', 'UA-60732327-9');  /* production */
app.constant('urlFormats', {
    "android": {
        "googleDefault": "https://play.google.com/store/apps/details?id=com.mcafee.security.safefamily&referrer=utm_source%3Dlandingpage%26utm_medium%3Dweblink",
        "googlePlay": "https://play.google.com/store/apps/details?id=com.mcafee.security.safefamily&referrer=utm_source%3Dlandingpage%26utm_medium%3Dweblink%26account_number%3D"
    },
    "ios": {
        "appstoreDefault": "https://itunes.apple.com/app/apple-store/id1156285759?pt=14394&ct=family.mcafee.com&mt=8",
        "appStore": "https://safefamily.mcafee.com/api/activation/ios/"
    },
    "windows": {
        "windowsDefault": "https://download.mcafee.com/products/safefamily/v1/SafeFamilySetup.exe",
        "windowsStore": "https://download.mcafee.com/products/safefamily/v1/SafeFamilySetup.exe"
        
    }
});
// "http://download.mcafee.com/products/safefamily/v1/SafeFamilySetup.exe" - windowsDefault
// "" - windowsStore
//app.constant('googleAnalyticsTrackingId', 'UA-39904839-4');  /* QA */
/*
QA Server URL -
    "windows": {
        "windowsDefault": "https://s3.amazonaws.com/mfs-appsqa/content/download/SafeFamilySetup.exe",
        "windowsStore": "https://safefamily-qa.mcafee.com/api/activation/win"
    }
*/
app.constant('supportedLanguages', [
    'en-au',
    'pt-br',
    'en-ca',
    'fr-ca',
    'cs',
    'fr',
    'de',
	'de-ch',
    'en-in',
    'it',
    'ja',
    'en-my',
    'es-mx',
    'es-co',
    'es-ar',
    'es-pe',
    'es-cl',
    'nl',
    'en-ph',
    'pt',
    'ru',
    'ko-kr',
    'es',
    'tr',   
    'en-gb',    
	'en',
    'pl',
    'fi',
    'nb-no',
    'sv-se',
    'da-dk',
    'el-gr',
    'en-sg',
    'hu-hu',
    'zh-hk',
    'zh-tw',
	'sk-sk',
	'sr-sr',
	'hr-hr'
]);
